/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { SharedLinkAccess } from "./SharedLinkAccess";
export const UpdateDataClipRequest = core.serialization.object({
    name: core.serialization.string(),
    description: core.serialization.string().optional(),
    status: core.serialization.string().optional(),
    collaborators: core.serialization.list(core.serialization.string()).optional(),
    sharedLinkAccess: SharedLinkAccess.optional(),
});
